import { render, staticRenderFns } from "./installation-module.vue?vue&type=template&id=8507f6e2&"
import script from "./installation-module.vue?vue&type=script&lang=js&"
export * from "./installation-module.vue?vue&type=script&lang=js&"
import style0 from "./installation-module.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../production/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports